import {
    PURCHASE_LIST,
    PURCHASE_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';

/**
 * Get UserData Login
 */
export const getPurchaseList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/PurchaseOrder/GetPurchaseOrderList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                dispatch({
                    type: PURCHASE_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: PURCHASE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return error;
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getPurchaseDetails = (payload) => {
    return dispatch => {
        const url = `v1/PurchaseOrder/GetPurchaseOrderByID?PurchaseOrderID=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const addPurchaseDetails = (payload) => {
    const url = `v1/PurchaseOrder/CreatePurchaseOrder`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getPurchaseList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updatePurchaseDetails = (payload) => {
    const url = `v1/PurchaseOrder/UpdatePurchaseOrder`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getPurchaseList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} url 
 * @returns 
 */
export const getSearchAPI = (url) => {
    return dispatch => {
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} url 
 * @returns 
 */
export const getAddressAPI = (id) => {
    return APICall('get', {}, `v1/AutoSuggestion/GetFullAddress?AccountID=${id}`).then(result => {
        if (result?.statuscode === 200) {
            return result?.data?.[0]?.completeAddress ?? '';
        } else {
            return "";
        }
    }, error => {
        return '';
    });
};

export const getContactDetails = (id) => {
    return APICall('get', {}, `v1/AutoSuggestion/GetFullAddress?AccountID=${id}`).then(result => {
        if (result?.statuscode === 200) {
            return result?.data?.[0] ?? '';
        } else {
            return "";
        }
    }, error => {
        return '';
    });
};

/**
 * 
 * @param {*} url 
 * @returns 
 */
export const getAddresswithfulldetail = (id, companyId = null) => {
    const companyParam = companyId ? `&companyId=${companyId}` : '';
    return APICall('get', {}, `v1/AutoSuggestion/GetFullAddress?AccountID=${id}${companyParam}`).then(result => {
        if (result?.statuscode === 200) {
            return result;
        } else {
            return "";
        }
    }, error => {
        return '';
    });
};

/**
 * File Upload APIs
 * @param {*} url 
 * @param {*} payload 
 * @returns 
 */
export const uploadPurchaseDocument = (url, payload) => {
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
}

export const uploadPurchaseDocumentnew = (url, formData, onProgress) => {
    return axios.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => {
            const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percent);
        }
    });
};


export const deletePurchaseDocument = (url, payload) => {
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
}

export const listPurchaseDocument = (url, payload) => {
    const fullUrl = `${url}${payload}`;
    return APICall('get', {}, fullUrl, false, true).then(async result => {
        if (result) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
}

// export const listPurchaseDocument = (url, payload = {}) => {
//     const queryString = new URLSearchParams(payload).toString();
//     const separator = url.includes("?") ? "&" : "?";
//     const fullUrl = queryString ? `${url}${separator}${queryString}` : url;

//     return APICall('get', {}, fullUrl, false, true)
//         .then((result) => result || false)
//         .catch((error) => error);
// };


